export const email = 'EMAIL';
export const paper = 'PAPER';
export const zoomit = 'ZOOMIT';
export const bankTransfer = 'BANK_TRANSFER';
export const directDebit = 'DIRECT_DEBIT';
export const directDebitAndBankTransfer = 'DIRECT_DEBIT_AND_BANK_TRANSFER';
